import { render } from "./BookingsPhotographer.vue?vue&type=template&id=80bed076"
import script from "./BookingsPhotographer.vue?vue&type=script&lang=js"
export * from "./BookingsPhotographer.vue?vue&type=script&lang=js"

import "./BookingsPhotographer.vue?vue&type=style&index=0&id=80bed076&lang=scss"

import exportComponent from "C:\\laragon\\www\\runpixie_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
